webpackJsonp([8],{

/***/ 123:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_normalize_css__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_normalize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_normalize_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "app",
  data: function data() {
    return {
      showHeaderNavigation: false
    };
  },
  methods: {
    isFrontPage: function isFrontPage() {
      return this.$route.path === "/";
    }
  },
  watch: {
    $route: function $route() {
      this.showHeaderNavigation = false;
    }
  }
});

/***/ }),

/***/ 124:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(23);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var _STADTKATALOG_CONFIG = {"siteName":"Seestadt.bot","geoFenceName":"seestadt","mapZoom":16,"mapCenter":[48.224479,16.502969],"clusterOptions":{"maxClusterRadius":20},"botUrl":"https://stadtbots.appspot.com/web/seestadtbot"},
    siteName = _STADTKATALOG_CONFIG.siteName;


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "sk-overview",
  data: function data() {
    return {
      loading: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])(["overview"]), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(["hasNextOverviewPage", "hasPrevOverviewPage"]), {
    rageStart: function rageStart() {
      return this.overview.page * this.overview.size + 1;
    },
    rangeEnd: function rangeEnd() {
      return Math.min(this.overview.total, this.overview.page * this.overview.size + this.overview.size);
    },
    currentPage: function currentPage() {
      return this.overview.page + 1;
    },
    validPage: function validPage() {
      return this.overview.page >= 0 && this.rageStart <= this.overview.total;
    },
    maxPage: function maxPage() {
      return Math.ceil(this.overview.total / this.overview.size);
    },
    currentPageClass: function currentPageClass() {
      if (this.overview.page === 0) {
        return "first-page";
      } else if (!this.hasNextOverviewPage) {
        return "last-page";
      }

      return "normal-page";
    }
  }),
  watch: {
    $route: function $route() {
      var _this = this;

      this.setPage();
      this.loading = true;
      this.$store.dispatch("updateOverview").then(function () {
        _this.loading = false;
      });
    }
  },
  methods: {
    setPage: function setPage() {
      if (this.$route.query.page) {
        var pageCandidate = parseInt(this.$route.query.page, 10);
        if (!isNaN(pageCandidate) && pageCandidate > 0) {
          this.overview.page = pageCandidate - 1;
        } else {
          this.$router.replace({ name: "sk-overview" });
        }
      } else {
        this.overview.page = 0;
      }
    }
  },
  created: function created() {
    var _this2 = this;

    document.title = "Überblick - " + siteName;

    this.setPage();
    this.loading = true;
    this.$store.dispatch("updateOverview").then(function () {
      _this2.loading = false;
    });
  }
});

/***/ }),

/***/ 133:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_StadtKatalogSearch__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StadtKatalogPromotions__ = __webpack_require__(136);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var _STADTKATALOG_CONFIG = {"siteName":"Seestadt.bot","geoFenceName":"seestadt","mapZoom":16,"mapCenter":[48.224479,16.502969],"clusterOptions":{"maxClusterRadius":20},"botUrl":"https://stadtbots.appspot.com/web/seestadtbot"},
    siteName = _STADTKATALOG_CONFIG.siteName;




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "seestadtbot-search",
  components: {
    "sk-search": __WEBPACK_IMPORTED_MODULE_2__components_StadtKatalogSearch__["a" /* default */],
    "sk-promotions": __WEBPACK_IMPORTED_MODULE_3__components_StadtKatalogPromotions__["a" /* default */]
  },
  data: function data() {
    return {
      demoQueries: ["Arzt", "Apotheke", "Restaurant", "Bäckerei", "Buchhandlung", "Spar", "Coworking"]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])(["geoFenceName", "totalHits", "promotionEntries"]), {
    showSuggestions: function showSuggestions() {
      return this.totalHits <= 0;
    },
    showPromotions: function showPromotions() {
      return window.__PRERENDER__ === undefined && this.promotionEntries.length > 0;
    },
    proposalUrl: function proposalUrl() {
      return "https://app.stadtkatalog.org/stk/proposeEntry" + (this.geoFenceName !== null ? "?geoFenceName=" + this.geoFenceName : "");
    }
  }),
  methods: {
    setQuery: function setQuery(query) {
      this.$store.commit("setQuery", query);
      this.$refs.search.queryStadtKatalog();
      this.$refs.search.focusSearchField();
    }
  },
  created: function created() {
    document.title = "Seestadt-Verzeichnis - " + siteName;
    this.$store.commit("resetQueryStates");
    this.$store.dispatch("updatePromotionEntries");
  }
});

/***/ }),

/***/ 134:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StadtKatalogSearch_vue__ = __webpack_require__(135);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a8c626c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StadtKatalogSearch_vue__ = __webpack_require__(300);
function injectStyle (ssrContext) {
  __webpack_require__(298)
}
var normalizeComponent = __webpack_require__(19)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5a8c626c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StadtKatalogSearch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a8c626c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StadtKatalogSearch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 135:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(23);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var MIN_QUERY_LENGTH = 3;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "sk-search",
  data: function data() {
    return {
      useAutocompleteStyle: true,
      error: ""
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    query: {
      get: function get() {
        return this.$store.state.query;
      },
      set: function set(value) {
        this.$store.commit("setQuery", value);
      }
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapState */])(["totalHits", "hits", "querySize", "queryFrom", "geoFenceName", "loading"]), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(["totalPages", "currentPage", "hasPrevPage", "hasNextPage"]), {
    hasQuery: function hasQuery() {
      return this.query && this.query.length >= MIN_QUERY_LENGTH;
    },
    proposeEntryUrl: function proposeEntryUrl() {
      return "https://app.stadtkatalog.org/stk/proposeEntry" + (this.geoFenceName !== null ? "?geoFenceName=" + this.geoFenceName : "");
    }
  }),
  methods: {
    queryStadtKatalog: function queryStadtKatalog() {
      var _this = this;

      this.$store.dispatch("updateHits").then(function () {
        // track a site search
        if (window._paq && _this.totalHits >= 0) {
          window._paq.push(["trackSiteSearch", _this.query, false, _this.totalHits]);
        }
      }).catch(function (e) {
        if (e.message === "Failed to fetch") {
          _this.error = "Verbindung zum StadtKatalog konnte nicht hergestellt werden.";
        } else {
          _this.error = "StadtKatalog konnte nicht abgefragt werden.";
        }
      });
    },
    debouncedQueryStadtKatalog: __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default()(function () {
      if (this.query.length >= MIN_QUERY_LENGTH) {
        // eager setLoading to prevent flashes in the autocomplete
        this.$store.commit("setLoading", true);
        this.setListStyle(true);
        this.queryStadtKatalog();
      } else if (this.query === "") {
        this.$store.commit("resetQueryStates");
      }
    }, 450),
    focusSearchField: function focusSearchField() {
      this.$refs.searchField.focus();
    },
    clearSearch: function clearSearch() {
      this.query = "";
      this.$refs.searchField.focus();
    },
    setListStyle: function setListStyle(useAutocomplete) {
      this.useAutocompleteStyle = useAutocomplete === true;
      var url = new URL(document.location);
      if (this.useAutocompleteStyle) {
        url.searchParams.delete("q");
        window.history.replaceState({}, document.title, url);
      } else {
        url.searchParams.set("q", encodeURIComponent(this.query));
        window.history.replaceState({}, document.title, url);
      }
    },
    nextPage: function nextPage() {
      if (this.queryFrom + this.querySize < this.totalHits) {
        this.$store.commit("setQueryFrom", this.queryFrom + this.querySize);
        this.queryStadtKatalog();
      }
    },
    prevPage: function prevPage() {
      if (this.queryFrom > 0) {
        this.$store.commit("setQueryFrom", Math.max(this.queryFrom - this.querySize, 0));
        this.queryStadtKatalog();
      }
    }
  },
  created: function created() {
    this.$store.commit("resetQueryStates");
    var params = new URL(document.location).searchParams;
    var query = decodeURIComponent(params.get("q") || "");
    if (query.length >= MIN_QUERY_LENGTH) {
      this.query = decodeURIComponent(query);
      this.setListStyle(false);
      this.queryStadtKatalog();
    }
    this.$watch("query", function () {
      this.debouncedQueryStadtKatalog();
    });
  },
  mounted: function mounted() {
    this.focusSearchField();
  }
});

/***/ }),

/***/ 136:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StadtKatalogPromotions_vue__ = __webpack_require__(137);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bbfa61a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StadtKatalogPromotions_vue__ = __webpack_require__(304);
function injectStyle (ssrContext) {
  __webpack_require__(301)
}
var normalizeComponent = __webpack_require__(19)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StadtKatalogPromotions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bbfa61a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StadtKatalogPromotions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 137:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EntryPromotions__ = __webpack_require__(155);

//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "sk-promotions",
  components: {
    EntryPromotions: __WEBPACK_IMPORTED_MODULE_3__EntryPromotions__["a" /* default */]
  },
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])(["promotionDays", "promotionEntries"]), {
    sortedEntryPromotions: function sortedEntryPromotions() {
      if (!this.promotionEntries) {
        return [];
      }

      var startLowerBound = __WEBPACK_IMPORTED_MODULE_2_moment__().startOf("day");
      var endUpperBound = __WEBPACK_IMPORTED_MODULE_2_moment__().add(this.promotionDays, "days").endOf("day");

      return this.promotionEntries.map(function (entry) {
        return {
          id: entry.id,
          data: entry.data,
          promotions: entry.data.promotions.map(function (promotion) {
            promotion.start = __WEBPACK_IMPORTED_MODULE_2_moment__(promotion.start, "YYYY-MM-DDTHH:mm:ss.SSSZZ");
            promotion.end = __WEBPACK_IMPORTED_MODULE_2_moment__(promotion.end, "YYYY-MM-DDTHH:mm:ss.SSSZZ");

            return promotion;
          }).filter(function (promotion) {
            return promotion.start.isSameOrAfter(startLowerBound) && promotion.start.isSameOrBefore(endUpperBound) || promotion.end.isSameOrAfter(startLowerBound) && promotion.end.isSameOrBefore(endUpperBound);
          }).sort(function (a, b) {
            return a.valueOf() - b.valueOf();
          })
        };
      }).filter(function (entry) {
        return entry.promotions.length > 0;
      }).sort(function (entryA, entryB) {
        return entryA.promotions[0].start.valueOf() - entryB.promotions[0].start.valueOf();
      }).slice(0, 5);
    }
  })
});

/***/ }),

/***/ 138:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "sk-entry-promotions",
  props: {
    promotions: {
      type: Array,
      required: true
    },
    headlineLevel: {
      type: Number,
      default: 3
    },
    defaultDaysIntoFuture: {
      type: Number,
      default: 7
    }
  },
  data: function data() {
    return {
      now: __WEBPACK_IMPORTED_MODULE_0_moment__(),
      showAllPromotions: false
    };
  },

  computed: {
    hasFuturePromotions: function hasFuturePromotions() {
      return this.promotions.some(this.isTooFarInFuture);
    }
  },
  methods: {
    showHref: function showHref(promotion) {
      return promotion.href && /^https?:\/\/.+$/.test(promotion.href);
    },
    readableURL: function readableURL(promotion) {
      try {
        return new URL(promotion.href).hostname;
      } catch (e) {
        return promotion.href;
      }
    },
    showDateDiff: function showDateDiff(promotion) {
      return this.now.isSameOrAfter(promotion.start) && promotion.end.diff(this.now, "days") <= 3;
    },
    dateDiff: function dateDiff(promotion) {
      return promotion.end.diff(this.now, "days");
    },
    isSameYear: function isSameYear(promotion) {
      return promotion.start.year() === promotion.end.year();
    },
    isSameMonth: function isSameMonth(promotion) {
      return promotion.start.isSame(promotion.end, "month");
    },
    isSameDay: function isSameDay(promotion) {
      return promotion.start.isSame(promotion.end, "day");
    },
    isTooFarInFuture: function isTooFarInFuture(promotion) {
      return promotion.start.isAfter(__WEBPACK_IMPORTED_MODULE_0_moment__().add(this.defaultDaysIntoFuture, "day"), "day");
    }
  }
});

/***/ }),

/***/ 139:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_StadtKatalogSearch__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StadtKatalogPromotions__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Bot__ = __webpack_require__(156);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "frontpage-seestadtbot",
  components: {
    Bot: __WEBPACK_IMPORTED_MODULE_4__Bot__["a" /* default */],
    "sk-search": __WEBPACK_IMPORTED_MODULE_2__components_StadtKatalogSearch__["a" /* default */],
    "sk-promotions": __WEBPACK_IMPORTED_MODULE_3__components_StadtKatalogPromotions__["a" /* default */]
  },
  data: function data() {
    return {
      demoQueries: [],
      isDesktop: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])(["geoFenceName", "totalHits", "promotionEntries"]), {
    showSuggestions: function showSuggestions() {
      return this.totalHits <= 0;
    },
    showPromotions: function showPromotions() {
      return window.__PRERENDER__ === undefined && this.promotionEntries.length > 0;
    },
    proposalUrl: function proposalUrl() {
      return "https://app.stadtkatalog.org/stk/proposeEntry" + (this.geoFenceName !== null ? "?geoFenceName=" + this.geoFenceName : "");
    }
  }),
  methods: {
    sendText: function sendText(text) {
      if (text && text.length <= 250) {
        if (text !== "") {
          this.$refs.seestadtbot.sendText(text);
        }
      } else {
        window.alert("Der Text darf maximal 250 Zeichen lang sein!");
      }
    },
    setQuery: function setQuery(query) {
      this.$store.commit("setQuery", query);
      this.$refs.search.queryStadtKatalog();
      this.$refs.search.focusSearchField();
    }
  },
  created: function created() {
    var _this = this;

    var mql = window.matchMedia("(min-width: 1020px)");
    this.isDesktop = mql.matches === true;
    try {
      // Chrome & Firefox
      mql.addEventListener("change", function () {
        _this.isDesktop = mql.matches === true;
      });
    } catch (e1) {
      try {
        // Safari
        mql.addListener(function (e) {
          _this.isDesktop = mql.matches === true;
        });
      } catch (e2) {
        console.error(e2);
      }
    }

    document.title = {"siteName":"Seestadt.bot","geoFenceName":"seestadt","mapZoom":16,"mapCenter":[48.224479,16.502969],"clusterOptions":{"maxClusterRadius":20},"botUrl":"https://stadtbots.appspot.com/web/seestadtbot"}.siteName;
    this.$store.commit("resetQueryStates");
    this.$store.dispatch("updatePromotionEntries");
  },
  mounted: function mounted() {
    var url = new URL(document.location);
    var text = url.searchParams.get("text");
    if (text) {
      this.$refs.seestadtbot.sendText(text);
      this.$router.replace({ path: '/', query: {} });
    }
  }
});

/***/ }),

/***/ 140:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_whatwg_fetch__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_whatwg_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_marked__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_marked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_marked__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var _STADTKATALOG_CONFIG = {"siteName":"Seestadt.bot","geoFenceName":"seestadt","mapZoom":16,"mapCenter":[48.224479,16.502969],"clusterOptions":{"maxClusterRadius":20},"botUrl":"https://stadtbots.appspot.com/web/seestadtbot"},
    botUrl = _STADTKATALOG_CONFIG.botUrl;


function getUUID() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0,
        v = c === "x" ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "bot",
  props: {
    fullscreen: {
      type: Boolean,
      required: false
    }
  },
  data: function data() {
    return {
      userId: null,
      isLoading: false,
      isOnboarding: false,
      chatText: "",
      statements: []
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapState */])([]), {
    hasChatText: function hasChatText() {
      return this.chatText.trim() !== "";
    },
    placeholder: function placeholder() {
      return this.$mq === "mobile" ? "Schreibe eine Nachricht …" : "Schreibe dem Seestadt.bot eine Nachricht …";
    }
  }),
  methods: {
    addStatements: function addStatements(statements) {
      this.statements = this.statements.concat(statements);
      if (localStorage) {
        localStorage.setItem("bot-stored-statements", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.statements.slice(-10) || []));
      }
    },
    updateUI: function updateUI() {
      var _this = this;

      this.isLoading = false;
      this.chatText = "";
      this.$refs.chatText.focus();
      this.$nextTick(function () {
        _this.$refs.scrollArea.scrollTop = _this.$refs.scrollArea.scrollHeight;
      });
    },
    sendText: function sendText(text) {
      var _this2 = this;

      var waitForOnboarding = this.isOnboarding;
      if (!waitForOnboarding) {
        this.chatText = text;
        this.$refs.chatText.focus();
      }

      setTimeout(function () {
        if (waitForOnboarding) {
          _this2.chatText = text;
          _this2.$refs.chatText.focus();
        }

        if (_this2.chatText === text) {
          _this2.queryBot();
        }
      }, (waitForOnboarding ? 3250 : 700) + Math.random() * 200);
    },
    queryBot: function queryBot() {
      var _this3 = this;

      if (!this.hasChatText) {
        return;
      }
      this.isLoading = true;
      this.$nextTick(function () {
        _this3.$refs.scrollArea.scrollTop = _this3.$refs.scrollArea.scrollHeight;
      });
      this.statements.push({
        type: "sent-message",
        message: this.chatText
      });
      fetch(botUrl, {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        headers: {
          "Content-Type": "application/json"
        },
        body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
          id: this.userId,
          type: "text",
          text: this.chatText.trim()
        })
      }).then(function (response) {
        if (response.ok) {
          return response.json();
        }

        throw new Error("Network error.");
      }).then(function (json) {
        _this3.addStatements(json);
      }).catch(function () {
        _this3.addStatements([{ type: "text", text: "😓 Leider kann der Bot gerade nicht abgefragt werden.", sendOptions: { textFormat: "plain" } }]);
      }).finally(function () {
        _this3.updateUI();
      });
    },
    sendCallback: function sendCallback(payload) {
      var _this4 = this;

      this.isLoading = true;
      this.$nextTick(function () {
        _this4.$refs.scrollArea.scrollTop = _this4.$refs.scrollArea.scrollHeight;
      });
      fetch(botUrl, {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        headers: {
          "Content-Type": "application/json"
        },
        body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
          id: this.userId,
          type: "callback",
          text: payload
        })
      }).then(function (response) {
        if (response.ok) {
          return response.json();
        }

        throw new Error("Network error.");
      }).then(function (json) {
        _this4.addStatements(json);
      }).finally(function () {
        _this4.updateUI();
      });
    },
    parseMarkdown: function parseMarkdown(md) {
      return __WEBPACK_IMPORTED_MODULE_4_marked__(md);
    },
    hasButtons: function hasButtons(statement) {
      return statement.sendOptions && Array.isArray(statement.sendOptions.buttons) && statement.sendOptions.buttons.length > 0;
    },
    onboardUser: function onboardUser() {
      var _this5 = this;

      this.isLoading = true;
      this.isOnboarding = true;
      this.$nextTick(function () {
        _this5.$refs.scrollArea.scrollTop = _this5.$refs.scrollArea.scrollHeight;
      });
      setTimeout(function () {
        _this5.addStatements([{
          "type": "markdown",
          "markdown": "**Willkommen beim Seestadt.bot!**\nDu kannst hier mir mit chatten. Soll ich dir meine Funktionen erklären?",
          "sendOptions": {
            "textFormat": "markdown",
            "buttons": [{ "type": "callback", "title": "💡 Funktionen zeigen", "payload": "hilfe" }]
          }
        }]);

        if (_this5.fullscreen === true) {
          _this5.isLoading = true;
          _this5.$nextTick(function () {
            _this5.$refs.scrollArea.scrollTop = _this5.$refs.scrollArea.scrollHeight;
          });
          setTimeout(function () {
            _this5.addStatements([{
              "type": "markdown",
              "markdown": "Du benutzt eine Chat-App? Dann findest du mich auch hier:",
              "sendOptions": {
                "textFormat": "markdown",
                "buttons": [{ "type": "url", "title": "In Facebook Messenger öffnen", "url": "https://m.me/SeestadtBot" }, { "type": "url", "title": "In Telegram öffnen", "url": "https://telegram.me/SeestadtBot" }, { "type": "callback", "title": "❓ Hilfe", "payload": "hilfe" }]
              }
            }]);
            _this5.updateUI();
            _this5.isOnboarding = false;
          }, 1150);
        } else {
          _this5.updateUI();
          _this5.isOnboarding = false;
        }
      }, 2000);
    }
  },
  created: function created() {
    if (localStorage) {
      var storedUserId = localStorage.getItem("bot-user-id");
      if (!storedUserId) {
        this.userId = getUUID();
        localStorage.setItem("bot-user-id", this.userId);
      } else {
        this.userId = storedUserId;
      }

      // restore last statements
      try {
        var storedStatments = JSON.parse(localStorage.getItem("bot-stored-statements") || "[]");
        if (Array.isArray(storedStatments)) {
          this.statements = storedStatments;
        }
      } catch (e) {
        console.error("Could not restore statements. " + e);
      }
    } else {
      this.userId = getUUID();
    }

    console.log("This client has the user id '" + this.userId + "'");
  },
  mounted: function mounted() {
    this.$refs.scrollArea.scrollTop = this.$refs.scrollArea.scrollHeight;
    this.$refs.chatText.focus();

    // to improve onboarding, create some artificial dialog
    if (localStorage) {
      if (localStorage.getItem("bot-stored-statements") === null) {
        this.onboardUser();
      }
    }
  }
});

/***/ }),

/***/ 155:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EntryPromotions_vue__ = __webpack_require__(138);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53da35ff_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EntryPromotions_vue__ = __webpack_require__(303);
function injectStyle (ssrContext) {
  __webpack_require__(302)
}
var normalizeComponent = __webpack_require__(19)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-53da35ff"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EntryPromotions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53da35ff_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EntryPromotions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 156:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Bot_vue__ = __webpack_require__(140);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e17319dc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Bot_vue__ = __webpack_require__(312);
function injectStyle (ssrContext) {
  __webpack_require__(308)
}
var normalizeComponent = __webpack_require__(19)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Bot_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e17319dc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Bot_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 161:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_typed_array_buffer__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_typed_array_buffer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_typed_array_buffer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_typed_data_view__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_typed_data_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_typed_data_view__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_typed_int8_array__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_typed_int8_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_typed_int8_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_typed_uint8_array__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_typed_uint8_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_typed_uint8_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_typed_uint8_clamped_array__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_typed_uint8_clamped_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_typed_uint8_clamped_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_typed_int16_array__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_typed_int16_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_typed_int16_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_typed_uint16_array__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_typed_uint16_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_typed_uint16_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_typed_int32_array__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_typed_int32_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_typed_int32_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_typed_uint32_array__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_typed_uint32_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_typed_uint32_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_typed_float32_array__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_typed_float32_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_typed_float32_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_typed_float64_array__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_typed_float64_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_typed_float64_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_map__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_set__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_weak_map__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_weak_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_weak_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_weak_set__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_weak_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_weak_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_apply__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_apply___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_apply__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_reflect_construct__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_reflect_construct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_reflect_construct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_reflect_define_property__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_reflect_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_reflect_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_reflect_delete_property__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_reflect_delete_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_reflect_delete_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_reflect_get__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_reflect_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_reflect_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_reflect_get_own_property_descriptor__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_reflect_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_reflect_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_reflect_get_prototype_of__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_reflect_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_reflect_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_reflect_has__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_reflect_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_reflect_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_reflect_is_extensible__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_reflect_is_extensible___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_reflect_is_extensible__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_reflect_own_keys__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_reflect_own_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_reflect_own_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_reflect_prevent_extensions__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_reflect_prevent_extensions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_reflect_prevent_extensions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_reflect_set__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_reflect_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_reflect_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_reflect_set_prototype_of__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_reflect_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_reflect_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_promise__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_core_js_modules_es6_symbol__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_core_js_modules_es6_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_core_js_modules_es6_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_object_freeze__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_object_freeze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_core_js_modules_es6_object_seal__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_core_js_modules_es6_object_seal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_core_js_modules_es6_object_seal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_core_js_modules_es6_object_prevent_extensions__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_core_js_modules_es6_object_prevent_extensions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_core_js_modules_es6_object_prevent_extensions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_core_js_modules_es6_object_is_frozen__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_core_js_modules_es6_object_is_frozen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_core_js_modules_es6_object_is_frozen__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_core_js_modules_es6_object_is_sealed__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_core_js_modules_es6_object_is_sealed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_core_js_modules_es6_object_is_sealed__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_core_js_modules_es6_object_is_extensible__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_core_js_modules_es6_object_is_extensible___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_core_js_modules_es6_object_is_extensible__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_core_js_modules_es6_object_get_own_property_descriptor__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_core_js_modules_es6_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_core_js_modules_es6_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_core_js_modules_es6_object_get_prototype_of__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_core_js_modules_es6_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_core_js_modules_es6_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_core_js_modules_es6_object_keys__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_core_js_modules_es6_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38_core_js_modules_es6_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_core_js_modules_es6_object_get_own_property_names__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_core_js_modules_es6_object_get_own_property_names___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39_core_js_modules_es6_object_get_own_property_names__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_core_js_modules_es6_object_assign__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_core_js_modules_es6_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40_core_js_modules_es6_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_core_js_modules_es6_object_is__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_core_js_modules_es6_object_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41_core_js_modules_es6_object_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_core_js_modules_es6_object_set_prototype_of__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_core_js_modules_es6_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42_core_js_modules_es6_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_core_js_modules_es6_function_name__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_core_js_modules_es6_function_name___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43_core_js_modules_es6_function_name__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_core_js_modules_es6_string_raw__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_core_js_modules_es6_string_raw___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44_core_js_modules_es6_string_raw__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_core_js_modules_es6_string_from_code_point__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_core_js_modules_es6_string_from_code_point___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45_core_js_modules_es6_string_from_code_point__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_core_js_modules_es6_string_code_point_at__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_core_js_modules_es6_string_code_point_at___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46_core_js_modules_es6_string_code_point_at__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_core_js_modules_es6_string_repeat__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_core_js_modules_es6_string_repeat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47_core_js_modules_es6_string_repeat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_core_js_modules_es6_string_starts_with__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_core_js_modules_es6_string_starts_with___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48_core_js_modules_es6_string_starts_with__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_core_js_modules_es6_string_ends_with__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_core_js_modules_es6_string_ends_with___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49_core_js_modules_es6_string_ends_with__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_core_js_modules_es6_string_includes__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_core_js_modules_es6_string_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50_core_js_modules_es6_string_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_core_js_modules_es6_regexp_flags__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_core_js_modules_es6_regexp_flags___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51_core_js_modules_es6_regexp_flags__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_core_js_modules_es6_regexp_match__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_core_js_modules_es6_regexp_match___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52_core_js_modules_es6_regexp_match__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_core_js_modules_es6_regexp_replace__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_core_js_modules_es6_regexp_replace___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53_core_js_modules_es6_regexp_replace__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54_core_js_modules_es6_regexp_split__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54_core_js_modules_es6_regexp_split___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54_core_js_modules_es6_regexp_split__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_core_js_modules_es6_regexp_search__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_core_js_modules_es6_regexp_search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55_core_js_modules_es6_regexp_search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56_core_js_modules_es6_array_from__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56_core_js_modules_es6_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56_core_js_modules_es6_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57_core_js_modules_es6_array_of__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57_core_js_modules_es6_array_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57_core_js_modules_es6_array_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58_core_js_modules_es6_array_copy_within__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58_core_js_modules_es6_array_copy_within___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58_core_js_modules_es6_array_copy_within__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59_core_js_modules_es6_array_find__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59_core_js_modules_es6_array_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59_core_js_modules_es6_array_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60_core_js_modules_es6_array_find_index__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60_core_js_modules_es6_array_find_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60_core_js_modules_es6_array_find_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61_core_js_modules_es6_array_fill__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61_core_js_modules_es6_array_fill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61_core_js_modules_es6_array_fill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62_core_js_modules_es6_array_iterator__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62_core_js_modules_es6_array_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_62_core_js_modules_es6_array_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63_core_js_modules_es6_number_is_finite__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63_core_js_modules_es6_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_63_core_js_modules_es6_number_is_finite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64_core_js_modules_es6_number_is_integer__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64_core_js_modules_es6_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_64_core_js_modules_es6_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65_core_js_modules_es6_number_is_safe_integer__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65_core_js_modules_es6_number_is_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_65_core_js_modules_es6_number_is_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66_core_js_modules_es6_number_is_nan__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66_core_js_modules_es6_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_66_core_js_modules_es6_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67_core_js_modules_es6_number_epsilon__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67_core_js_modules_es6_number_epsilon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67_core_js_modules_es6_number_epsilon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68_core_js_modules_es6_number_min_safe_integer__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68_core_js_modules_es6_number_min_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_68_core_js_modules_es6_number_min_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69_core_js_modules_es6_number_max_safe_integer__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69_core_js_modules_es6_number_max_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_69_core_js_modules_es6_number_max_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70_core_js_modules_es6_math_acosh__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70_core_js_modules_es6_math_acosh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_70_core_js_modules_es6_math_acosh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71_core_js_modules_es6_math_asinh__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71_core_js_modules_es6_math_asinh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_71_core_js_modules_es6_math_asinh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72_core_js_modules_es6_math_atanh__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72_core_js_modules_es6_math_atanh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_72_core_js_modules_es6_math_atanh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73_core_js_modules_es6_math_cbrt__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73_core_js_modules_es6_math_cbrt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_73_core_js_modules_es6_math_cbrt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74_core_js_modules_es6_math_clz32__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74_core_js_modules_es6_math_clz32___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_74_core_js_modules_es6_math_clz32__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75_core_js_modules_es6_math_cosh__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75_core_js_modules_es6_math_cosh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_75_core_js_modules_es6_math_cosh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76_core_js_modules_es6_math_expm1__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76_core_js_modules_es6_math_expm1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_76_core_js_modules_es6_math_expm1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77_core_js_modules_es6_math_fround__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77_core_js_modules_es6_math_fround___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_77_core_js_modules_es6_math_fround__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78_core_js_modules_es6_math_hypot__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78_core_js_modules_es6_math_hypot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_78_core_js_modules_es6_math_hypot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79_core_js_modules_es6_math_imul__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79_core_js_modules_es6_math_imul___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_79_core_js_modules_es6_math_imul__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80_core_js_modules_es6_math_log1p__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80_core_js_modules_es6_math_log1p___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_80_core_js_modules_es6_math_log1p__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81_core_js_modules_es6_math_log10__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81_core_js_modules_es6_math_log10___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_81_core_js_modules_es6_math_log10__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82_core_js_modules_es6_math_log2__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82_core_js_modules_es6_math_log2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_82_core_js_modules_es6_math_log2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83_core_js_modules_es6_math_sign__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83_core_js_modules_es6_math_sign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_83_core_js_modules_es6_math_sign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84_core_js_modules_es6_math_sinh__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84_core_js_modules_es6_math_sinh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_84_core_js_modules_es6_math_sinh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85_core_js_modules_es6_math_tanh__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85_core_js_modules_es6_math_tanh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_85_core_js_modules_es6_math_tanh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86_core_js_modules_es6_math_trunc__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86_core_js_modules_es6_math_trunc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_86_core_js_modules_es6_math_trunc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87_core_js_modules_es7_array_includes__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87_core_js_modules_es7_array_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_87_core_js_modules_es7_array_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88_core_js_modules_es7_object_values__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88_core_js_modules_es7_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_88_core_js_modules_es7_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89_core_js_modules_es7_object_entries__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89_core_js_modules_es7_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_89_core_js_modules_es7_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90_core_js_modules_es7_object_get_own_property_descriptors__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90_core_js_modules_es7_object_get_own_property_descriptors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_90_core_js_modules_es7_object_get_own_property_descriptors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91_core_js_modules_es7_string_pad_start__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91_core_js_modules_es7_string_pad_start___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_91_core_js_modules_es7_string_pad_start__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92_core_js_modules_es7_string_pad_end__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92_core_js_modules_es7_string_pad_end___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_92_core_js_modules_es7_string_pad_end__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93_core_js_modules_web_timers__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93_core_js_modules_web_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_93_core_js_modules_web_timers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94_core_js_modules_web_immediate__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94_core_js_modules_web_immediate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_94_core_js_modules_web_immediate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95_core_js_modules_web_dom_iterable__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95_core_js_modules_web_dom_iterable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_95_core_js_modules_web_dom_iterable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96_regenerator_runtime_runtime__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96_regenerator_runtime_runtime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_96_regenerator_runtime_runtime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97_vue__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__AppSeestadtBot__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__router__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100_vue_mq__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101_leaflet__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_101_leaflet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102_vue2_leaflet__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102_vue2_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_102_vue2_leaflet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103_vue2_leaflet_markercluster__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103_vue2_leaflet_markercluster___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_103_vue2_leaflet_markercluster__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__store__ = __webpack_require__(344);


































































































// step 1: prepare everything for tracking

var _paq = window._paq = _paq || [];
_paq.push(["setCookieDomain", "*.seestadt.bot"]);
_paq.push(["enableHeartBeatTimer",  true ? 7 : 45]);

(function () {
  var u = "https://stats.pnp-appserver.xyz/";
  _paq.push(['setTrackerUrl', u + 'matomo.php']);
  _paq.push(['setSiteId',  true ? "2" : "3"]);
  var d = document,
      g = d.createElement('script'),
      s = d.getElementsByTagName('script')[0];
  g.type = 'text/javascript';g.async = true;g.defer = true;g.src = u + 'matomo.js';s.parentNode.insertBefore(g, s);
})();

// step 2: initialize application





__WEBPACK_IMPORTED_MODULE_97_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_100_vue_mq__["a" /* default */], {
  breakpoints: { // default breakpoints - customize this
    mobile: 590,
    tablet: 1020,
    desktop: Infinity
  },
  defaultBreakpoint: "mobile" // customize this for SSR
});

__WEBPACK_IMPORTED_MODULE_97_vue__["a" /* default */].config.productionTip = false;

// maps + webpack fix for leaflet

delete __WEBPACK_IMPORTED_MODULE_101_leaflet___default.a.Icon.Default.prototype._getIconUrl;
__WEBPACK_IMPORTED_MODULE_101_leaflet___default.a.Icon.Default.mergeOptions({
  iconRetinaUrl: __webpack_require__(340),
  iconUrl: __webpack_require__(276),
  shadowUrl: __webpack_require__(341)
});



__WEBPACK_IMPORTED_MODULE_97_vue__["a" /* default */].component("v-map", __WEBPACK_IMPORTED_MODULE_102_vue2_leaflet___default.a.Map);
__WEBPACK_IMPORTED_MODULE_97_vue__["a" /* default */].component("v-tilelayer", __WEBPACK_IMPORTED_MODULE_102_vue2_leaflet___default.a.TileLayer);
__WEBPACK_IMPORTED_MODULE_97_vue__["a" /* default */].component("v-marker", __WEBPACK_IMPORTED_MODULE_102_vue2_leaflet___default.a.Marker);
__WEBPACK_IMPORTED_MODULE_97_vue__["a" /* default */].component("v-popup", __WEBPACK_IMPORTED_MODULE_102_vue2_leaflet___default.a.Popup);
__WEBPACK_IMPORTED_MODULE_97_vue__["a" /* default */].component("v-geo-json", __WEBPACK_IMPORTED_MODULE_102_vue2_leaflet___default.a.GeoJSON);
__WEBPACK_IMPORTED_MODULE_97_vue__["a" /* default */].component("v-marker-cluster", __WEBPACK_IMPORTED_MODULE_103_vue2_leaflet_markercluster___default.a);


__WEBPACK_IMPORTED_MODULE_104__store__["a" /* default */].state.promotionDays = 2;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_97_vue__["a" /* default */]({
  el: "#app",
  router: __WEBPACK_IMPORTED_MODULE_99__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_104__store__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_98__AppSeestadtBot__["a" /* default */]);
  }
});

/***/ }),

/***/ 274:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppSeestadtBot_vue__ = __webpack_require__(123);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2002afae_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppSeestadtBot_vue__ = __webpack_require__(279);
function injectStyle (ssrContext) {
  __webpack_require__(275)
}
var normalizeComponent = __webpack_require__(19)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppSeestadtBot_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2002afae_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppSeestadtBot_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 275:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 276:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAApCAYAAADAk4LOAAAFgUlEQVR4Aa1XA5BjWRTN2oW17d3YaZtr2962HUzbDNpjszW24mRt28p47v7zq/bXZtrp/lWnXr337j3nPCe85NcypgSFdugCpW5YoDAMRaIMqRi6aKq5E3YqDQO3qAwjVWrD8Ncq/RBpykd8oZUb/kaJutow8r1aP9II0WmLKLIsJyv1w/kqw9Ch2MYdB++12Onxee/QMwvf4/Dk/Lfp/i4nxTXtOoQ4pW5Aj7wpici1A9erdAN2OH64x8OSP9j3Ft3b7aWkTg/Fm91siTra0f9on5sQr9INejH6CUUUpavjFNq1B+Oadhxmnfa8RfEmN8VNAsQhPqF55xHkMzz3jSmChWU6f7/XZKNH+9+hBLOHYozuKQPxyMPUKkrX/K0uWnfFaJGS1QPRtZsOPtr3NsW0uyh6NNCOkU3Yz+bXbT3I8G3xE5EXLXtCXbbqwCO9zPQYPRTZ5vIDXD7U+w7rFDEoUUf7ibHIR4y6bLVPXrz8JVZEql13trxwue/uDivd3fkWRbS6/IA2bID4uk0UpF1N8qLlbBlXs4Ee7HLTfV1j54APvODnSfOWBqtKVvjgLKzF5YdEk5ewRkGlK0i33Eofffc7HT56jD7/6U+qH3Cx7SBLNntH5YIPvODnyfIXZYRVDPqgHtLs5ABHD3YzLuespb7t79FY34DjMwrVrcTuwlT55YMPvOBnRrJ4VXTdNnYug5ucHLBjEpt30701A3Ts+HEa73u6dT3FNWwflY86eMHPk+Yu+i6pzUpRrW7SNDg5JHR4KapmM5Wv2E8Tfcb1HoqqHMHU+uWDD7zg54mz5/2BSnizi9T1Dg4QQXLToGNCkb6tb1NU+QAlGr1++eADrzhn/u8Q2YZhQVlZ5+CAOtqfbhmaUCS1ezNFVm2imDbPmPng5wmz+gwh+oHDce0eUtQ6OGDIyR0uUhUsoO3vfDmmgOezH0mZN59x7MBi++WDL1g/eEiU3avlidO671bkLfwbw5XV2P8Pzo0ydy4t2/0eu33xYSOMOD8hTf4CrBtGMSoXfPLchX+J0ruSePw3LZeK0juPJbYzrhkH0io7B3k164hiGvawhOKMLkrQLyVpZg8rHFW7E2uHOL888IBPlNZ1FPzstSJM694fWr6RwpvcJK60+0HCILTBzZLFNdtAzJaohze60T8qBzyh5ZuOg5e7uwQppofEmf2++DYvmySqGBuKaicF1blQjhuHdvCIMvp8whTTfZzI7RldpwtSzL+F1+wkdZ2TBOW2gIF88PBTzD/gpeREAMEbxnJcaJHNHrpzji0gQCS6hdkEeYt9DF/2qPcEC8RM28Hwmr3sdNyht00byAut2k3gufWNtgtOEOFGUwcXWNDbdNbpgBGxEvKkOQsxivJx33iow0Vw5S6SVTrpVq11ysA2Rp7gTfPfktc6zhtXBBC+adRLshf6sG2RfHPZ5EAc4sVZ83yCN00Fk/4kggu40ZTvIEm5g24qtU4KjBrx/BTTH8ifVASAG7gKrnWxJDcU7x8X6Ecczhm3o6YicvsLXWfh3Ch1W0k8x0nXF+0fFxgt4phz8QvypiwCCFKMqXCnqXExjq10beH+UUA7+nG6mdG/Pu0f3LgFcGrl2s0kNNjpmoJ9o4B29CMO8dMT4Q5ox8uitF6fqsrJOr8qnwNbRzv6hSnG5wP+64C7h9lp30hKNtKdWjtdkbuPA19nJ7Tz3zR/ibgARbhb4AlhavcBebmTHcFl2fvYEnW0ox9xMxKBS8btJ+KiEbq9zA4RthQXDhPa0T9TEe69gWupwc6uBUphquXgf+/FrIjweHQS4/pduMe5ERUMHUd9xv8ZR98CxkS4F2n3EUrUZ10EYNw7BWm9x1GiPssi3GgiGRDKWRYZfXlON+dfNbM+GgIwYdwAAAAASUVORK5CYII="

/***/ }),

/***/ 278:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 279:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'seestadtbot-app': true, 'frontpage': _vm.isFrontPage()},attrs:{"id":"app"}},[_c('header',{staticClass:"content-container"},[_c('div',{staticClass:"content-box"},[_c('div',{staticClass:"header-content"},[_c('div',{staticClass:"header-logo"},[(!_vm.isFrontPage())?_c('router-link',{attrs:{"to":"/"}},[_c('h1',[_vm._v("Seestadt.bot")])]):_c('div',[_c('h1',[_vm._v("\n              Seestadt.bot\n            ")])])],1),_vm._v(" "),_c('div',{staticClass:"header-navigation"},[_c('button',{attrs:{"aria-controls":"header-navigation-links","aria-haspopup":"true","aria-expanded":_vm.showHeaderNavigation ? 'true' : 'false'},on:{"click":function($event){_vm.showHeaderNavigation = !_vm.showHeaderNavigation}}},[_c('svg',{attrs:{"viewBox":"0 0 100 80","role":"img","aria-label":"Navigation öffnen"}},[_c('title',[_vm._v("Navigation öffnen")]),_vm._v(" "),_c('rect',{attrs:{"width":"100","height":"20","rx":"8"}}),_vm._v(" "),_c('rect',{attrs:{"y":"30","width":"100","height":"20","rx":"8"}}),_vm._v(" "),_c('rect',{attrs:{"y":"60","width":"100","height":"20","rx":"8"}})])]),_vm._v(" "),_c('nav',{class:{ expanded: _vm.showHeaderNavigation },attrs:{"id":"header-navigation-links"}},[_c('router-link',{attrs:{"to":"/hilfe"}},[_vm._v("Hilfe")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/stadtkatalog/"}},[_vm._v("Seestadt‑Verzeichnis")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/stadtkatalog/karte"}},[_vm._v("Karte")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/ueber"}},[_vm._v("Impressum")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1)],1)])])])]),_vm._v(" "),_c('main',{staticClass:"content-container"},[_c('div',{staticClass:"content-box"},[_c('router-view')],1)]),_vm._v(" "),_c('footer',{staticClass:"footer"},[_c('router-link',{attrs:{"to":"/ueber"}},[_vm._v("Impressum")]),_vm._v(" | "),_c('router-link',{attrs:{"to":"/datenschutz"}},[_vm._v("Datenschutz")])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"https://telegram.me/SeestadtBot"}},[_c('img',{attrs:{"src":__webpack_require__(98),"alt":""}}),_vm._v(" Telegram öffnen")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"https://m.me/SeestadtBot"}},[_c('img',{attrs:{"src":__webpack_require__(99),"alt":""}}),_vm._v(" Messenger öffnen")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 280:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_StadtKatalogOverview__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_seestadtbot_SeestadtBotSearch__ = __webpack_require__(296);



// sync loading



var _STADTKATALOG_CONFIG = {"siteName":"Seestadt.bot","geoFenceName":"seestadt","mapZoom":16,"mapCenter":[48.224479,16.502969],"clusterOptions":{"maxClusterRadius":20},"botUrl":"https://stadtbots.appspot.com/web/seestadtbot"},
    siteName = _STADTKATALOG_CONFIG.siteName;

var isSeestadtBot = siteName === "Seestadt.bot";

// async loading / code splitting
var Entry = function Entry() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 354));
};
var StadtKatalogMap = function StadtKatalogMap() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 355));
};
var Privacy = function Privacy() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 356));
};
var SeestadtBotPrivacy = function SeestadtBotPrivacy() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 357));
};
var About = function About() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 358));
};
var SeestadtBotHilfe = function SeestadtBotHilfe() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 359));
};
var SeestadtBotAbout = function SeestadtBotAbout() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 360));
};

// CommonJS syntax for dynamic import
var FrontPage = __webpack_require__(306).default;

/**
 * Piwik / Matomo tracking
 */
function trackPageView(url, referrerUrl) {
  if (window._paq) {
    // wait for nextTick + add 250ms delay to
    // give some time to refresh document.title before tracking
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].nextTick(function () {
      setTimeout(function () {
        window._paq.push(['setCustomUrl', url], ['setDocumentTitle', document.title]);
        if (referrerUrl) {
          window._paq.push(['setReferrerUrl', referrerUrl]);
        }
        window._paq.push(['trackPageView'], ['enableLinkTracking']);
      }, 250);
    });
  }
}

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: "history",
  routes: [{
    path: "/",
    name: "home",
    component: FrontPage
  }, {
    path: (isSeestadtBot ? "/stadtkatalog" : "") + "/eintrag/:id",
    name: "entry",
    component: Entry
  }, {
    path: (isSeestadtBot ? "/stadtkatalog" : "") + "/ueberblick",
    name: "sk-overview",
    component: __WEBPACK_IMPORTED_MODULE_2__components_StadtKatalogOverview__["a" /* default */]
  }, {
    path: (isSeestadtBot ? "/stadtkatalog" : "") + "/karte",
    name: "sk-map",
    component: StadtKatalogMap
  }, {
    path: "/ueber",
    name: "about",
    component: isSeestadtBot ? SeestadtBotAbout : About
  }, {
    path: "/datenschutz",
    name: "privacy",
    component: isSeestadtBot ? SeestadtBotPrivacy : Privacy
  }],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

// Special routes for the Seestadt.bot domain
if (siteName === "Seestadt.bot") {
  router.addRoutes([{
    path: "/stadtkatalog",
    name: "search",
    component: __WEBPACK_IMPORTED_MODULE_3__components_seestadtbot_SeestadtBotSearch__["a" /* default */]
  }, {
    path: "/hilfe",
    name: "help",
    component: SeestadtBotHilfe
  }]);
}

var firstRun = true;

router.afterEach(function (to, from) {
  trackPageView(to.fullPath, !firstRun ? document.location + (from.fullPath !== "/" ? from.fullPath : "") : document.referrer);
  firstRun = false;
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 282:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StadtKatalogOverview_vue__ = __webpack_require__(124);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_743b503d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StadtKatalogOverview_vue__ = __webpack_require__(295);
function injectStyle (ssrContext) {
  __webpack_require__(283)
}
var normalizeComponent = __webpack_require__(19)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-743b503d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StadtKatalogOverview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_743b503d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StadtKatalogOverview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 283:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 295:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-wrapper"},[_c('h1',[_vm._v("Überblick")]),_vm._v(" "),(_vm.loading)?_c('div',[_vm._v("\n    Lade ...\n  ")]):_c('div',[_c('ol',{staticClass:"entry-list",attrs:{"start":_vm.rageStart}},_vm._l((_vm.overview.entries),function(entry){return _c('li',{key:entry._id},[_c('router-link',{attrs:{"to":{ name: 'entry', params: { id: entry._id }}}},[_c('h2',[_vm._v(_vm._s(entry.name))])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(entry.description))])],1)}),0),_vm._v(" "),(_vm.validPage)?_c('div',{staticClass:"pager"},[(_vm.hasPrevOverviewPage)?_c('router-link',{staticClass:"button",attrs:{"to":{ name: 'sk-overview', query: { page: _vm.currentPage - 1 }}}},[_vm._v("\n        Zurück\n      ")]):_vm._e(),_vm._v(" "),_c('p',{class:_vm.currentPageClass},[_vm._v("Seite "+_vm._s(_vm.currentPage)+" von "+_vm._s(_vm.maxPage)),_c('br'),_vm._v("Insgesamt "+_vm._s(_vm.overview.total)+" Einträge")]),_vm._v(" "),(_vm.hasNextOverviewPage)?_c('router-link',{staticClass:"button",attrs:{"to":{ name: 'sk-overview', query: { page: _vm.currentPage + 1 }}}},[_vm._v("\n        Weiter\n      ")]):_vm._e()],1):_c('p',[_vm._v("\n      Ungültige Seite!\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 296:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SeestadtBotSearch_vue__ = __webpack_require__(133);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b000306c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SeestadtBotSearch_vue__ = __webpack_require__(305);
function injectStyle (ssrContext) {
  __webpack_require__(297)
}
var normalizeComponent = __webpack_require__(19)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SeestadtBotSearch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b000306c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SeestadtBotSearch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 297:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 298:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 300:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-wrapper"},[_c('div',{staticClass:"search-bar"},[_c('label',{staticClass:"sr-only",attrs:{"for":"query"}},[_vm._v("Search")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.query),expression:"query"}],ref:"searchField",staticClass:"search-field",attrs:{"id":"query","type":"text","maxlength":"500","autocomplete":"off","title":"Suche","spellcheck":"false"},domProps:{"value":(_vm.query)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.setListStyle(false)},"input":function($event){if($event.target.composing){ return; }_vm.query=$event.target.value}}}),_vm._v(" "),(_vm.hasQuery && !_vm.loading)?_c('span',{staticClass:"search-status-indicator"},[_c('button',{attrs:{"aria-controls":"query"},on:{"click":_vm.clearSearch}},[_vm._v("×"),_c('span',{staticClass:"sr-only"},[_vm._v("Suche abbrechen")])])]):(_vm.loading)?_c('span',{staticClass:"search-status-indicator"},[_c('svg',{attrs:{"viewBox":"0 0 100 100","preserveAspectRatio":"xMidYMid"}},[_c('circle',{attrs:{"cx":"50","cy":"50","r":"25","stroke-width":"10","stroke":"#bababa","stroke-dasharray":"39.269908169872416 39.269908169872416","fill":"none","stroke-linecap":"round"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"rotate","repeatCount":"indefinite","dur":"1.333333333333333s","keyTimes":"0;1","values":"0 50 50;360 50 50"}})],1)])]):_vm._e()]),_vm._v(" "),_c('div',{class:{ 'result-wrapper': true, 'result-wrapper-autocomplete': _vm.useAutocompleteStyle, 'result-wrapper-list': !_vm.useAutocompleteStyle  }},[(!_vm.loading && _vm.totalHits > 0)?_c('div',[(!_vm.useAutocompleteStyle)?_c('div',{staticClass:"result-list-header"},[_vm._v("\n            Es\n            "),(_vm.totalHits > 1)?[_vm._v("wurden")]:[_vm._v("wurde")],_vm._v("\n            "+_vm._s(_vm.totalHits)+"\n            "),(_vm.totalHits > 1)?[_vm._v("Einträge")]:[_vm._v("Eintrag")],_vm._v("\n            gefunden:\n          ")],2):_vm._e(),_vm._v(" "),(_vm.hits.length > 0)?_c('ol',{staticClass:"results"},[_vm._l((_vm.hits),function(hit){return _c('li',{key:hit.id},[_c('router-link',{attrs:{"to":{ name: 'entry', params: { id: hit.id }}}},[_c('h3',[_vm._v(_vm._s(hit.data.name))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(hit.data.description))])])],1)}),_vm._v(" "),(_vm.useAutocompleteStyle)?_c('li',{staticClass:"list-footer"},[_vm._v("\n              Es\n              "),(_vm.totalHits > 1)?[_vm._v("wurden")]:[_vm._v("wurde")],_vm._v("\n              "+_vm._s(_vm.totalHits)+"\n              "),(_vm.totalHits > 1)?[_vm._v("Einträge")]:[_vm._v("Eintrag")],_vm._v("\n              gefunden.\n            ")],2):_vm._e()],2):_vm._e(),_vm._v(" "),(!_vm.useAutocompleteStyle)?_c('div',{staticClass:"page-navigation"},[(_vm.hasPrevPage)?_c('button',{staticClass:"button",on:{"click":function($event){return _vm.prevPage()}}},[_vm._v("Vorherige Seite")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"page-navigation-current-page"},[_vm._v("Seite "+_vm._s(_vm.currentPage)+" von "+_vm._s(_vm.totalPages))]),_vm._v(" "),(_vm.hasNextPage)?_c('button',{staticClass:"button",on:{"click":function($event){return _vm.nextPage()}}},[_vm._v("Nächste Seite")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.totalHits == 0 && !_vm.loading)?_c('div',{staticClass:"no-results"},[_c('p',[_vm._v("Es wurden keine Einträge für „"+_vm._s(_vm.query)+"“ gefunden.")]),_vm._v(" "),_c('p',{staticClass:"suggest-stadtkatalog-entry"},[_c('a',{staticClass:"button",attrs:{"href":_vm.proposeEntryUrl}},[_vm._v("\n                Neuen Eintrag vorschlagen\n              ")])])]):_vm._e()]):_vm._e()]),_vm._v(" "),(_vm.error !== '')?_c('div',{staticClass:"error"},[_c('h1',[_vm._v("Fehler aufgetreten")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.error))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 301:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 302:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 303:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ol',{class:{ 'show-all-promotions': _vm.showAllPromotions, 'entry-promotions': true }},_vm._l((_vm.promotions),function(promotion){return _c('li',{key:promotion.start,class:_vm.isTooFarInFuture(promotion) ? 'too-far' : ''},[(_vm.headlineLevel === 1)?_c('h1',[_vm._v(_vm._s(promotion.title))]):_vm._e(),_vm._v(" "),(_vm.headlineLevel === 2)?_c('h2',[_vm._v(_vm._s(promotion.title))]):_vm._e(),_vm._v(" "),(_vm.headlineLevel === 3)?_c('h3',[_vm._v(_vm._s(promotion.title))]):_vm._e(),_vm._v(" "),(_vm.headlineLevel === 4)?_c('h4',[_vm._v(_vm._s(promotion.title))]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"date-range"},[(_vm.showDateDiff(promotion))?[_c('span',{staticClass:"date-diff"},[(_vm.dateDiff(promotion) > 0)?[(_vm.dateDiff(promotion) > 1)?[_vm._v("\n                Noch "+_vm._s(_vm.dateDiff(promotion))+" Tage\n              ")]:[_vm._v("\n                Vorletzer Tag\n              ")]]:[_vm._v("\n              Letzter Tag\n            ")]],2),_vm._v("\n           – \n        ")]:_vm._e(),_vm._v(" "),(_vm.isSameYear(promotion))?[(_vm.isSameDay(promotion))?[_vm._v("\n            "+_vm._s(promotion.start.format("D. MMMM YYYY"))+"\n          ")]:(_vm.isSameMonth(promotion))?[_vm._v("\n            "+_vm._s(promotion.start.format("D."))+" bis "+_vm._s(promotion.end.format("D. MMMM YYYY"))+"\n          ")]:[_vm._v("\n            "+_vm._s(promotion.start.format("D. MMMM"))+" bis "+_vm._s(promotion.end.format("D. MMMM YYYY"))+"\n          ")]]:[_vm._v("\n          "+_vm._s(promotion.start.format("D. MMMM YYYY"))+" bis "+_vm._s(promotion.end.format("D. MMMM YYYY"))+"\n        ")]],2),_vm._v(" "),_c('p',{staticClass:"promotion-text"},[_vm._v(_vm._s(promotion.text))]),_vm._v(" "),(_vm.showHref(promotion))?_c('p',{staticClass:"promo-link ion-android-open"},[_c('a',{attrs:{"href":promotion.href},domProps:{"textContent":_vm._s(_vm.readableURL(promotion))}})]):_vm._e()])}),0),_vm._v(" "),(_vm.hasFuturePromotions)?_c('div',{staticClass:"show-future-promotions"},[_c('button',{staticClass:"button",on:{"click":function($event){_vm.showAllPromotions = !_vm.showAllPromotions}}},[(_vm.showAllPromotions)?_c('span',[_vm._v("Weniger ")]):_c('span',[_vm._v("Weitere ")]),_vm._v("\n      Angebote anzeigen …\n    ")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 304:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.sortedEntryPromotions.length > 0)?_c('ol',{staticClass:"promotions-wrapper"},_vm._l((_vm.sortedEntryPromotions),function(entry){return _c('li',{key:entry.id},[_c('h3',[_c('router-link',{attrs:{"to":{ name: 'entry', params: { id: entry.id } }}},[_vm._v(_vm._s(entry.data.name))])],1),_vm._v(" "),_c('entry-promotions',{attrs:{"promotions":entry.promotions,"headline-level":4}})],1)}),0):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 305:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"seestadtbot-search"},[_vm._m(0),_vm._v(" "),_c('sk-search',{ref:"search"}),_vm._v(" "),(_vm.showSuggestions)?[_c('section',{staticClass:"query-suggestions"},[_c('h2',[_vm._v("Populäre Suchbegriffe")]),_vm._v(" "),_c('ul',{staticClass:"suggestion-list"},_vm._l((_vm.demoQueries),function(query){return _c('li',{key:query},[_c('span',{staticClass:"button",on:{"click":function($event){return _vm.setQuery(query)}}},[_vm._v(_vm._s(query))])])}),0)]),_vm._v(" "),(_vm.showPromotions)?_c('section',{staticClass:"promotions"},[_c('h2',[_vm._v("Aktuelle Angebote und Aktionen")]),_vm._v(" "),_c('sk-promotions')],1):_vm._e(),_vm._v(" "),_c('section',[_c('h2',[_vm._v("Die Seestadt erkunden")]),_vm._v(" "),_c('ul',{staticClass:"suggestion-list"},[_c('li',{staticClass:"map-link"},[_c('router-link',{staticClass:"button",attrs:{"to":{ name: 'sk-map'}}},[_vm._v("Alles auf einer Karte")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"button",attrs:{"to":{ name: 'sk-map', query: { tag: '3420 :: einkaufen + genießen' } }}},[_vm._v("Einkaufen + Genießen")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"button",attrs:{"to":{ name: 'sk-map', query: { tag: '3420 :: gesundheit + freizeit' } }}},[_vm._v("Gesundheit + Freizeit")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"button",attrs:{"to":{ name: 'sk-map', query: { tag: '3420 :: bildung + kultur' } }}},[_vm._v("Bildung + Kultur")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"button",attrs:{"to":{ name: 'sk-map', query: { tag: '3420 :: wohnen + arbeiten' } }}},[_vm._v("Wohnen + Arbeiten")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"button",attrs:{"to":{ name: 'sk-map', query: { tag: '3420 :: nachbarschaft' } }}},[_vm._v("Nachbarschaft")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"button",attrs:{"to":{ name: 'sk-map', query: { tag: '3420 :: mobilität' } }}},[_vm._v("Mobilität")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"button",attrs:{"to":{ name: 'sk-overview' }}},[_vm._v("Alles in einer Liste")])],1)])]),_vm._v(" "),_c('section',{staticClass:"something-missing"},[_c('p',[_vm._v("\n        Fehlt dein Unternehmen oder Geschäft? Hast du einen Verein oder bietest ein Service in der Seestadt an?\n        Seestadt.bot basiert auf dem StadtKatalog, wo du dich einfach einträgst und damit auch hier erscheinst.\n      ")]),_vm._v(" "),_c('p',{staticClass:"suggest-stadtkatalog-entry"},[_c('a',{staticClass:"button",attrs:{"href":_vm.proposalUrl}},[_vm._v("\n          Eintrag vorschlagen\n        ")])])])]:_vm._e()],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_c('span',{staticClass:"hidden-mobile"},[_vm._v("Seestadt-")]),_vm._v("Verzeichnis")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 306:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FrontPageSeestadtBot_vue__ = __webpack_require__(139);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_191f1140_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FrontPageSeestadtBot_vue__ = __webpack_require__(313);
function injectStyle (ssrContext) {
  __webpack_require__(307)
}
var normalizeComponent = __webpack_require__(19)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FrontPageSeestadtBot_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_191f1140_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FrontPageSeestadtBot_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 307:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 308:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 312:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ messaging: true, fullscreen: _vm.fullscreen }},[_c('div',{staticClass:"input-area"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chatText),expression:"chatText"}],ref:"chatText",attrs:{"type":"text","placeholder":_vm.placeholder,"disabled":_vm.isLoading},domProps:{"value":(_vm.chatText)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.queryBot($event)},"input":function($event){if($event.target.composing){ return; }_vm.chatText=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"send-button",attrs:{"disabled":_vm.isLoading || !_vm.hasChatText,"aria-label":"Senden"},on:{"click":_vm.queryBot}},[_c('svg',{attrs:{"aria-hidden":"true","focusable":"false","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"fill":"currentColor","d":"M476 3.2L12.5 270.6c-18.1 10.4-15.8 35.6 2.2 43.2L121 358.4l287.3-253.2c5.5-4.9 13.3 2.6 8.6 8.3L176 407v80.5c0 23.6 28.5 32.9 42.5 15.8L282 426l124.6 52.2c14.2 6 30.4-2.9 33-18.2l72-432C515 7.8 493.3-6.8 476 3.2z"}})])])]),_vm._v(" "),_c('div',{ref:"scrollArea",staticClass:"messaging-history"},[_c('ol',{staticClass:"bot-dialog"},[_vm._l((_vm.statements),function(statement,index){return [(statement.type === 'sent-message')?_c('li',{class:{ 'sent-message': true, last: (index + 1 === _vm.statements.length || _vm.statements[index + 1].type !== 'sent-message') }},[_vm._v(_vm._s(statement.message))]):_vm._e(),_vm._v(" "),(statement.type === 'text')?_c('li',{class:{ 'bot-reply': true, last: (index + 1 === _vm.statements.length || _vm.statements[index + 1].type === 'sent-message') }},[_vm._v(_vm._s(statement.text))]):(statement.type === 'markdown')?_c('li',{class:{ 'bot-reply': true, 'type-markdown': true, last: (index + 1 === _vm.statements.length || _vm.statements[index + 1].type === 'sent-message') },domProps:{"innerHTML":_vm._s(_vm.parseMarkdown(statement.markdown))}}):(statement.type === 'image')?_c('li',{class:{ 'bot-reply': true, 'type-image': true, last: (index + 1 === _vm.statements.length || _vm.statements[index + 1].type === 'sent-message') }},[_c('img',{attrs:{"src":statement.imageUrl,"alt":"Foto"}}),_vm._v(" "),(statement.caption)?_c('div',[_vm._v(_vm._s(statement.caption))]):_vm._e()]):(statement.type === 'inlineCallback')?_c('li',{class:{ 'bot-reply': true, 'type-inline-callback': true, last: (index + 1 === _vm.statements.length || _vm.statements[index + 1].type === 'sent-message') }},[(statement.title)?_c('div',{staticClass:"inline-callback-title"},[_vm._v(_vm._s(statement.title))]):_vm._e(),_c('div',{staticClass:"inline-callback-buttons"},[_vm._l((statement.callbackButtons),function(button){return [(button.type === 'url')?_c('a',{attrs:{"target":"_blank","href":button.url}},[_vm._v(_vm._s(button.title))]):_vm._e(),_vm._v(" "),(button.type === 'callback')?_c('button',{on:{"click":function($event){return _vm.sendCallback(button.payload)}}},[_vm._v(_vm._s(button.title))]):_vm._e()]})],2)]):_vm._e(),_vm._v(" "),(_vm.hasButtons(statement))?_c('li',{class:{ 'button-list': true, 'one-column': statement.sendOptions.buttonsPerRow === 1, 'two-column': statement.sendOptions.buttonsPerRow === 2}},_vm._l((statement.sendOptions.buttons),function(button){return _c('div',{staticClass:"statement-button"},[(button.type === 'url')?_c('a',{attrs:{"target":"_blank","href":button.url}},[_vm._v(_vm._s(button.title))]):_vm._e(),_vm._v(" "),(button.type === 'callback')?_c('button',{on:{"click":function($event){return _vm.sendCallback(button.payload)}}},[_vm._v(_vm._s(button.title))]):_vm._e()])}),0):_vm._e()]})],2),_vm._v(" "),(_vm.isLoading)?_c('div',{staticClass:"loading-indicator"},[_c('svg',{attrs:{"viewBox":"0 0 100 100","preserveAspectRatio":"xMidYMid"}},[_c('circle',{attrs:{"cx":"84","cy":"50","r":"10","fill":"#6a6a6a"}},[_c('animate',{attrs:{"attributeName":"r","repeatCount":"indefinite","dur":"0.49019607843137253s","calcMode":"spline","keyTimes":"0;1","values":"10;0","keySplines":"0 0.5 0.5 1","begin":"0s"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"fill","repeatCount":"indefinite","dur":"1.9607843137254901s","calcMode":"discrete","keyTimes":"0;0.25;0.5;0.75;1","values":"#6a6a6a;#e2e2e2;#bdbdbd;#979797;#6a6a6a","begin":"0s"}})]),_c('circle',{attrs:{"cx":"16","cy":"50","r":"10","fill":"#6a6a6a"}},[_c('animate',{attrs:{"attributeName":"r","repeatCount":"indefinite","dur":"1.9607843137254901s","calcMode":"spline","keyTimes":"0;0.25;0.5;0.75;1","values":"0;0;10;10;10","keySplines":"0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1","begin":"0s"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"cx","repeatCount":"indefinite","dur":"1.9607843137254901s","calcMode":"spline","keyTimes":"0;0.25;0.5;0.75;1","values":"16;16;16;50;84","keySplines":"0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1","begin":"0s"}})]),_c('circle',{attrs:{"cx":"50","cy":"50","r":"10","fill":"#979797"}},[_c('animate',{attrs:{"attributeName":"r","repeatCount":"indefinite","dur":"1.9607843137254901s","calcMode":"spline","keyTimes":"0;0.25;0.5;0.75;1","values":"0;0;10;10;10","keySplines":"0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1","begin":"-0.49019607843137253s"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"cx","repeatCount":"indefinite","dur":"1.9607843137254901s","calcMode":"spline","keyTimes":"0;0.25;0.5;0.75;1","values":"16;16;16;50;84","keySplines":"0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1","begin":"-0.49019607843137253s"}})]),_c('circle',{attrs:{"cx":"84","cy":"50","r":"10","fill":"#bdbdbd"}},[_c('animate',{attrs:{"attributeName":"r","repeatCount":"indefinite","dur":"1.9607843137254901s","calcMode":"spline","keyTimes":"0;0.25;0.5;0.75;1","values":"0;0;10;10;10","keySplines":"0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1","begin":"-0.9803921568627451s"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"cx","repeatCount":"indefinite","dur":"1.9607843137254901s","calcMode":"spline","keyTimes":"0;0.25;0.5;0.75;1","values":"16;16;16;50;84","keySplines":"0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1","begin":"-0.9803921568627451s"}})]),_c('circle',{attrs:{"cx":"16","cy":"50","r":"10","fill":"#e2e2e2"}},[_c('animate',{attrs:{"attributeName":"r","repeatCount":"indefinite","dur":"1.9607843137254901s","calcMode":"spline","keyTimes":"0;0.25;0.5;0.75;1","values":"0;0;10;10;10","keySplines":"0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1","begin":"-1.4705882352941175s"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"cx","repeatCount":"indefinite","dur":"1.9607843137254901s","calcMode":"spline","keyTimes":"0;0.25;0.5;0.75;1","values":"16;16;16;50;84","keySplines":"0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1","begin":"-1.4705882352941175s"}})])])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 313:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"seestadtbot-frontpage"},[_c('div',{staticClass:"top-grid"},[_c('div',{staticClass:"top-grid-content"},[_c('h2',[_vm._v("Verwende den Bot in Chat-Apps")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('h2',[_vm._v("Du kannst fragen …")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("wann der 🚌 Bus bei der Johann-Kutschera-Gasse kommt "),_c('button',{on:{"click":function($event){return _vm.sendText('Bus JKG')}}},[_vm._v("Bus JKG")])]),_vm._v(" "),_c('li',[_vm._v("wann die nächste 🚇 U2 von der Seestadt abfährt "),_c('button',{on:{"click":function($event){return _vm.sendText('U2 Seestadt')}}},[_vm._v("U2 Seestadt")])]),_vm._v(" "),_c('li',[_vm._v("welche Öffi-Stationen es gibt "),_c('button',{on:{"click":function($event){return _vm.sendText('S')}}},[_vm._v("S")])]),_vm._v(" "),_c('li',[_vm._v("ob dein Lieblingsgeschäft offen hat, zum Beispiel\n          "),_c('button',{on:{"click":function($event){return _vm.sendText('United in Cycling')}}},[_vm._v("United in Cycling")])]),_vm._v(" "),_c('li',[_vm._v("wie warm es draußen ist "),_c('button',{on:{"click":function($event){return _vm.sendText('Wetter')}}},[_vm._v("Wetter")])]),_vm._v(" "),_c('li',[_vm._v("ob es noch genug 🚲 Leihräder gibt "),_c('button',{on:{"click":function($event){return _vm.sendText('SeestadtFLOTTE')}}},[_vm._v("SeestadtFLOTTE")])]),_vm._v(" "),_c('li',[_vm._v("wo 🐶 Hundezonen und 💩 Sackerlspender sind "),_c('button',{on:{"click":function($event){return _vm.sendText('Hundezone')}}},[_vm._v("Hundezone")])])]),_vm._v(" "),_c('p',[_vm._v("Weitere Funktionen "),_c('router-link',{attrs:{"to":"/hilfe"}},[_vm._v("findest du in der Online-Hilfe.")])],1)]),_vm._v(" "),_c('div',{staticClass:"top-grid-bot"},[_c('bot',{ref:"seestadtbot",attrs:{"fullscreen":!_vm.isDesktop}})],1)]),_vm._v(" "),_c('section',{staticClass:"something-missing"},[_c('h2',[_vm._v("Wie kannst du dich und dein Unternehmen im Seestadt.bot eintragen?")]),_vm._v(" "),_c('p',[_vm._v("\n      Fehlt dein Unternehmen oder Geschäft? Hast du einen Verein oder bietest ein Service in der Seestadt an?\n      Der Seestadt.bot basiert auf dem StadtKatalog, wo du dich einfach einträgst und damit auch hier erscheinst.\n      "),_c('a',{attrs:{"href":_vm.proposalUrl,"target":"_blank"}},[_vm._v("Eintrag vorschlagen")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"messenger-link-buttons"},[_c('a',{attrs:{"href":"https://telegram.me/SeestadtBot","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__(98),"alt":""}}),_vm._v("Telegram")]),_vm._v(" "),_c('a',{attrs:{"href":"https://m.me/SeestadtBot","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__(99),"alt":""}}),_vm._v("Messenger")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 340:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 341:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAApCAQAAAACach9AAACMUlEQVR4Ae3ShY7jQBAE0Aoz/f9/HTMzhg1zrdKUrJbdx+Kd2nD8VNudfsL/Th///dyQN2TH6f3y/BGpC379rV+S+qqetBOxImNQXL8JCAr2V4iMQXHGNJxeCfZXhSRBcQMfvkOWUdtfzlLgAENmZDcmo2TVmt8OSM2eXxBp3DjHSMFutqS7SbmemzBiR+xpKCNUIRkdkkYxhAkyGoBvyQFEJEefwSmmvBfJuJ6aKqKWnAkvGZOaZXTUgFqYULWNSHUckZuR1HIIimUExutRxwzOLROIG4vKmCKQt364mIlhSyzAf1m9lHZHJZrlAOMMztRRiKimp/rpdJDc9Awry5xTZCte7FHtuS8wJgeYGrex28xNTd086Dik7vUMscQOa8y4DoGtCCSkAKlNwpgNtphjrC6MIHUkR6YWxxs6Sc5xqn222mmCRFzIt8lEdKx+ikCtg91qS2WpwVfBelJCiQJwvzixfI9cxZQWgiSJelKnwBElKYtDOb2MFbhmUigbReQBV0Cg4+qMXSxXSyGUn4UbF8l+7qdSGnTC0XLCmahIgUHLhLOhpVCtw4CzYXvLQWQbJNmxoCsOKAxSgBJno75avolkRw8iIAFcsdc02e9iyCd8tHwmeSSoKTowIgvscSGZUOA7PuCN5b2BX9mQM7S0wYhMNU74zgsPBj3HU7wguAfnxxjFQGBE6pwN+GjME9zHY7zGp8wVxMShYX9NXvEWD3HbwJf4giO4CFIQxXScH1/TM+04kkBiAAAAAElFTkSuQmCC"

/***/ }),

/***/ 344:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_whatwg_fetch__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_whatwg_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(23);







__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* default */]);

var API_URL = "https://app.stadtkatalog.org/opendata/v1";
var _STADTKATALOG_CONFIG = {"siteName":"Seestadt.bot","geoFenceName":"seestadt","mapZoom":16,"mapCenter":[48.224479,16.502969],"clusterOptions":{"maxClusterRadius":20},"botUrl":"https://stadtbots.appspot.com/web/seestadtbot"},
    geoFenceName = _STADTKATALOG_CONFIG.geoFenceName;


/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* default */].Store({
  state: {
    loading: false,
    query: "",
    querySize: 10,
    queryFrom: 0,
    hits: [],
    totalHits: -1,
    geoFenceName: geoFenceName,
    geoJson: {},
    geoJsonTagFilter: null,
    promotionDays: 7,
    promotionEntries: [],
    overview: {
      entries: [],
      size: 25,
      page: 0,
      total: 0
    }
  },
  getters: {
    standardParameters: function standardParameters(state) {
      return ["size=" + state.querySize, "from=" + state.queryFrom, "validAfter=" + new Date().toISOString()].join("&");
    },
    updateUrl: function updateUrl(state, getters) {
      return API_URL + "/search/fulltext?q=" + encodeURIComponent(state.query) + "&" + getters.standardParameters + (state.geoFenceName !== null ? "&geoFenceName=" + state.geoFenceName : "");
    },
    geoJsonUrl: function geoJsonUrl(state, getters) {
      return API_URL + "/export/geojson?size=1000" + (state.geoFenceName !== null ? "&geoFenceName=" + state.geoFenceName : "");
    },
    promotionsUrl: function promotionsUrl(state, getters) {
      return API_URL + "/search/promotions?size=10&" + "promotionStartAfter=" + encodeURIComponent(__WEBPACK_IMPORTED_MODULE_3_moment__().startOf("day").format()) + "&promotionStartBefore=" + encodeURIComponent(__WEBPACK_IMPORTED_MODULE_3_moment__().add(state.promotionDays, "days").endOf("day").format()) + (state.geoFenceName !== null ? "&geoFenceName=" + state.geoFenceName : "");
    },
    entryListUrl: function entryListUrl(state, getters) {
      return API_URL + "/export/json?sortField=name&sortOrder=asc&size=" + state.overview.size + "&from=" + state.overview.page * state.overview.size + (state.geoFenceName !== null ? "&geoFenceName=" + state.geoFenceName : "");
    },
    currentPage: function currentPage(state) {
      return Math.floor(state.queryFrom / state.querySize) + 1;
    },
    totalPages: function totalPages(state) {
      return Math.ceil(state.totalHits / state.querySize);
    },
    hasNextPage: function hasNextPage(state) {
      return state.queryFrom + state.querySize < state.totalHits;
    },
    hasPrevPage: function hasPrevPage(state) {
      return state.queryFrom > 0;
    },
    hasNextOverviewPage: function hasNextOverviewPage(state) {
      return state.overview.total > state.overview.size * state.overview.page + state.overview.size;
    },
    hasPrevOverviewPage: function hasPrevOverviewPage(state) {
      return state.overview.page > 0;
    }
  },
  actions: {
    updateHits: function updateHits(_ref) {
      var _this = this;

      var commit = _ref.commit;

      commit("setLoading", true);
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        fetch(_this.getters.updateUrl).then(function (response) {
          if (response.ok) {
            return response.json();
          }

          throw new Error("Network error.");
        }).then(function (json) {
          commit("setResultState", {
            totalHits: json.totalHits,
            hits: json.hits
          });
          commit("setLoading", false);
          resolve();
        }).catch(function (ex) {
          commit("setLoading", false);
          console.error(ex);
          commit("setResultState", {
            totalHits: -1,
            hits: []
          });
          reject(ex);
        });
      });
    },
    updateGeoJson: function updateGeoJson(_ref2) {
      var _this2 = this;

      var commit = _ref2.commit;

      commit("setLoading", true);
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        fetch(_this2.getters.geoJsonUrl).then(function (response) {
          commit("setLoading", false);
          return response.json();
        }).then(function (json) {
          if (_this2.state.geoJsonTagFilter !== null) {
            json.features = json.features.filter(function (feature) {
              return feature.properties.tags.indexOf(_this2.state.geoJsonTagFilter) >= 0;
            });
          }

          commit("setGeoJson", {
            object: json
          });
          resolve();
        }).catch(function (ex) {
          console.error(ex);
          commit("setGeoJson", {
            object: {}
          });
          reject();
        });
      });
    },
    updatePromotionEntries: function updatePromotionEntries(_ref3) {
      var _this3 = this;

      var commit = _ref3.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        fetch(_this3.getters.promotionsUrl).then(function (response) {
          return response.json();
        }).then(function (json) {
          commit("setPromotionEntries", {
            entries: json.hits
          });
          resolve();
        }).catch(function (ex) {
          console.error(ex);
          commit("setPromotionEntries", {
            entries: []
          });
          reject();
        });
      });
    },
    updateOverview: function updateOverview(_ref4) {
      var _this4 = this;

      var commit = _ref4.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        fetch(_this4.getters.entryListUrl).then(function (response) {
          commit("setOverviewTotal", {
            count: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(response.headers.get("Export-Total-Results"))
          });
          return response.json();
        }).then(function (json) {
          commit("setOverviewEntries", {
            entries: json
          });
          resolve();
        }).catch(function (ex) {
          console.error(ex);
          commit("setOverviewEntries", {
            entries: []
          });
          reject();
        });
      });
    },
    prevOverviewPage: function prevOverviewPage(_ref5) {
      var commit = _ref5.commit;

      if (this.getters.hasPrevOverviewPage) {
        commit("prevOverviewPage");
      }
    },
    nextOverviewPage: function nextOverviewPage(_ref6) {
      var commit = _ref6.commit;

      if (this.getters.hasNextOverviewPage) {
        commit("nextOverviewPage");
      }
    }
  },
  mutations: {
    resetQueryStates: function resetQueryStates(state) {
      state.loading = false;
      state.query = "";
      state.queryFrom = 0;
      state.totalHits = -1;
      state.hits = [];
    },
    setLoading: function setLoading(state, loading) {
      state.loading = loading === true;
    },
    setQuery: function setQuery(state, query) {
      state.query = query;
    },
    setResultState: function setResultState(state, _ref7) {
      var hits = _ref7.hits,
          totalHits = _ref7.totalHits;

      state.hits = hits;
      state.totalHits = totalHits;
    },
    setQueryFrom: function setQueryFrom(state, queryFrom) {
      state.queryFrom = queryFrom;
    },
    setGeoJsonTagFilter: function setGeoJsonTagFilter(state, filter) {
      state.geoJsonTagFilter = filter;
    },
    setGeoJson: function setGeoJson(state, _ref8) {
      var object = _ref8.object;

      state.geoJson = object;
    },
    setPromotionEntries: function setPromotionEntries(state, _ref9) {
      var entries = _ref9.entries;

      state.promotionEntries = entries;
    },
    setOverviewTotal: function setOverviewTotal(state, _ref10) {
      var count = _ref10.count;

      state.overview.total = count;
    },
    setOverviewEntries: function setOverviewEntries(state, _ref11) {
      var entries = _ref11.entries;

      state.overview.entries = entries;
    },
    nextOverviewPage: function nextOverviewPage(state) {
      state.overview.page++;
    },
    prevOverviewPage: function prevOverviewPage(state) {
      state.overview.page--;
    }
  }
}));

/***/ }),

/***/ 353:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPHBhdGggZD0iTTMgMjJ2LTIwbDE4IDEwLTE4IDEweiIgZmlsbD0iI2ZmZiIvPgo8L3N2Zz4K"

/***/ }),

/***/ 98:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 99:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiPjxsaW5lYXJHcmFkaWVudCBpZD0iYSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiIHgxPSI1MTIiIHkxPSIxMS41IiB4Mj0iNTEyIiB5Mj0iMTAwNS41Ij48c3RvcCBvZmZzZXQ9IjAiIHN0b3AtY29sb3I9IiMwMGIyZmYiLz48c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiMwMDZhZmYiLz48L2xpbmVhckdyYWRpZW50PjxwYXRoIGQ9Ik01MTIgMTEuNWMtMjgwIDAtNDk3IDIwNS4xLTQ5NyA0ODIuMSAwIDE0NC45IDU5LjQgMjcwLjEgMTU2LjEgMzU2LjYgOC4xIDcuMyAxMyAxNy40IDEzLjQgMjguM2wyLjcgODguNGMuOSAyOC4yIDMwIDQ2LjUgNTUuOCAzNS4ybDk4LjYtNDMuNWM4LjQtMy43IDE3LjctNC40IDI2LjUtMiA0NS4zIDEyLjUgOTMuNiAxOS4xIDE0My45IDE5LjEgMjgwIDAgNDk3LTIwNS4xIDQ5Ny00ODIuMVM3OTIgMTEuNSA1MTIgMTEuNXoiIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBmaWxsPSJ1cmwoI2EpIi8+PHBhdGggZD0iTTIxMy42IDYzNC42bDE0Ni0yMzEuNmMyMy4yLTM2LjggNzMtNDYgMTA3LjgtMTkuOWwxMTYuMSA4Ny4xYzEwLjcgOCAyNS4zIDcuOSAzNS45LS4xbDE1Ni44LTExOWMyMC45LTE1LjkgNDguMyA5LjIgMzQuMiAzMS40TDY2NC41IDYxNGMtMjMuMiAzNi44LTczIDQ2LTEwNy44IDE5LjlsLTExNi4xLTg3LjFjLTEwLjctOC0yNS4zLTcuOS0zNS45LjFMMjQ3LjggNjY2Yy0yMC45IDE1LjktNDguMy05LjItMzQuMi0zMS40eiIgZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGZpbGw9IiNmZmYiLz48L3N2Zz4="

/***/ })

},[161]);


// WEBPACK FOOTER //
// static/js/app.333c556fc48fc8341c02.js